import React from "react";
import { Row, Col, Image } from "react-bootstrap";

// IMAGES
import ourStory from "../../images/Company/OurStory.jpg";
import ourVision from "../../images/Company/OurVision.JPG";
import ourMission from "../../images/Company/OurMission.jpg";
import coreValues from "../../images/Company/OurCoreValues.JPG";
import workCulture1 from "../../images/Company/Workculture1.JPG";
import workCulture2 from "../../images/Company/Workculture2.JPG";
import workCulture3 from "../../images/Company/Workculture3.JPG";
import Goals from "../../images/Company/Goals1.JPG";
import contactUs from "../../images/Company/Contactus.JPG";

import OurMission1 from "../../images/Mission-Vision-Profile/OurMission1.jpg";
import OurVision1 from "../../images/Mission-Vision-Profile/OurVision1.jpg";

import styles from "./Company.module.css";

import { company } from "../../data";
import ContactUsFooter from "../contactUsFooter/ContactUsFooter";

const Company = () => {
  return (
    <div className={styles["aboutUsWrapper"]}>
      <div className={`${styles["aboutUsContainer"]} mt-5`}>
          {/* Our Story section hidden */}
          
          <Row className={styles["company__card-row"]}>
            <Col>
              <h3>
                {company.ourVision.title}
              </h3>
              <p>{company.ourVision.text}</p>
            </Col>
          </Row>

          <Row className={styles["company__card-row"]}>
            <Col>
              <h3>
                {company.ourMission.title}
              </h3>
              <p>{company.ourMission.text}</p>
            </Col>
          </Row>

          <Row className={styles["company__card-row"]}>
            <Col>
              <h3>Core Values</h3>
              {company.coreValues.map((data, i) => (
                <div key={i}>
                  <li className="mb-2">
                    <strong>{data.title}:</strong> {data.text}
                  </li>
                </div>
              ))}
            </Col>
          </Row>

          {/* Goals section hidden */}
          
          <Row className={styles["company__card-row"]}>
            <Col>
              <h3>{company.workCulture.title}</h3>
              <p>{company.workCulture.text}</p>
            </Col>
          </Row>
          <Row>
            <Col className={styles["contact__address"]}>
              <h2>Our Offices</h2>
              <br></br>
              <Row className={styles["officesRow"]}>
                <Col xs={12} md={6} className={styles["officeCol"]}>
                  <p>
                    <h3>India</h3>
                    <br />
                    <b>Registered Office:</b>
                    <br />
                    <i>MSME Registration #: UDYAM-TN-20-0046643</i>
                    <br />
                    5/102, Sitheri Pallakkadu, Attur, Salem, Tamilnadu 636101
                    <br />
                    Mobile:
                    <a href="tel:+91 8807349930 "> +91 8807349930</a>
                    <br />
                    For General queries:
                    <a href="mailto:admin@encycdata.com"> admin@encycdata.com</a>
                    <br />
                  </p>
                </Col>
                <Col xs={12} md={6} className={styles["officeCol"]}>
                  <p>
                    <b>CoWorking Space (Bangalore):</b>
                    <br />
                    No.115 & 116, 4th floor, NR TOWERS, 50 ft Main Road, 8th Cross, Celebrity Paradise Electronic City Phase 1, Bengaluru, Karnataka 560100
                    <br />
                    Mobile:
                    <a href="tel:+91 8807349930 "> +91 8807349930</a>
                    <br />
                    For General queries:
                    <a href="mailto:admin@encycdata.com"> admin@encycdata.com</a>
                    <br />
                  </p>
                </Col>
              </Row>
              <Row className={styles["officesMapsRow"]}>
                <Col xs={12} md={6} className={styles["officeCol"]}>
                  <div className={styles.officeMapBlock}>
                    <iframe
                      src="https://maps.google.com/maps?q=5/102,+Sitheri+Pallakkadu,+Attur,+Salem,+Tamilnadu+636101&t=&z=15&ie=UTF8&iwloc=&output=embed"
                      width="100%"
                      height="300"
                      style={{ border: 0, borderRadius: "10px" }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Registered Office Location"
                    ></iframe>
                    <a
                      href="https://maps.app.goo.gl/T5fLc8bxphnruE4E8"
                      target="_blank"
                      rel="noreferrer"
                      className={styles.mapLink}
                    >
                      View on Google Maps
                    </a>
                  </div>
                </Col>
                <Col xs={12} md={6} className={styles["officeCol"]}>
                  <div className={styles.officeMapBlock}>
                    <iframe
                      src="https://maps.google.com/maps?q=No.115+%26+116,+4th+floor,+NR+TOWERS,+50+ft+Main+Road,+8th+Cross,+Celebrity+Paradise+Electronic+City+Phase+1,+Bengaluru,+Karnataka+560100&t=&z=15&ie=UTF8&iwloc=&output=embed"
                      width="100%"
                      height="300"
                      style={{ border: 0, borderRadius: "10px" }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Bangalore Office Location"
                    ></iframe>
                    <a
                      href="https://maps.app.goo.gl/GrhdJrNtjULAbbDW6"
                      target="_blank"
                      rel="noreferrer"
                      className={styles.mapLink}
                    >
                      View on Google Maps
                    </a>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      {/* Contact Us section hidden for now
      <div className={styles.companyContactWrap}>
        <ContactUsFooter />
      </div>
      */}
    </div>
  );
};

export default Company;
